// SCRIBE-07 back-link: hands a mapped Report Builder note's extract text to
// the Assessment Scribe page across a route navigation, WITHOUT putting it in
// the URL. `note.text` is clinical/PHI content — per this repo's frontend
// security guidance ("avoid sensitive data in URL query parameters"), it must
// not sit in the browser address bar/history for the life of the tab. The
// AssessmentSection `id` alone (non-sensitive) still travels via the
// `section` URL search param — see router.tsx.
//
// A plain module-scope variable, not a store: this is a one-shot value
// consumed exactly once by the destination page's mount effect, not reactive
// UI state anything subscribes to. It's also naturally safe against a
// refresh/back-navigation re-triggering the highlight animation — a page
// reload resets this module's state to null, same as any other in-memory
// value (mirrors the discipline in RecordingDock's module-scope buffer).

let pendingHighlightText: string | null = null;

/** Called by the "Locate in Assessment Scribe" action, right before navigating. */
export const setPendingHighlightText = (text: string): void => {
  pendingHighlightText = text;
};

/** Called once by AudioTranscriberPage on mount. Consumes the value — a
 * second read (e.g. a later remount) gets null, not a stale repeat. */
export const takePendingHighlightText = (): string | null => {
  const text = pendingHighlightText;
  pendingHighlightText = null;
  return text;
};

/** Test-only reset. */
export const resetPendingHighlightTextForTest = (): void => {
  pendingHighlightText = null;
};
